export default __webpack_public_path__ + "static/media/Photo 1 - BR - Jalousies.54807a67.png";